import { IModule } from '../interface/module';
export class Module implements IModule {
     constructor(public ModuleId : number,public ModuleName : string, public IsModuleAccess : boolean){
        
    }
}



// WEBPACK FOOTER //
// ./src/app/section/master/model/module.ts